export default class Tab {
  constructor() {

    // タブに対してクリックイベントを適用
    const tabBtn = document.getElementsByClassName('js-tab');

    for(let i = 0; i < tabBtn.length; i++) {
      tabBtn[i].addEventListener('click', tabSwitch);
    }

    // タブをクリックすると実行する関数
    function tabSwitch(){
      // タブのclassの値を変更
      document.getElementsByClassName('isActive')[0].classList.remove('isActive');
      this.classList.add('isActive');

      const arrayTabs = Array.prototype.slice.call(tabBtn);
      const index = arrayTabs.indexOf(this);

      // コンテンツのclassの値を変更
      document.getElementsByClassName('isShow')[0].classList.remove('isShow');
      document.getElementsByClassName('tab-area')[index].classList.add('isShow');
    }

    const urlParam = location.search.substring(1);

    // URLにパラメータが存在する場合
    if(urlParam) {
      if(urlParam == 'admin') {
        const tabItemBtn = document.querySelectorAll('.js-tab.admin');
        const tabItemCont = document.querySelectorAll('.tab-area.admin');

        document.getElementsByClassName('isActive')[0].classList.remove('isActive');
        tabItemBtn[0].classList.add('isActive');
        document.getElementsByClassName('isShow')[0].classList.remove('isShow');
        tabItemCont[0].classList.add('isShow');
      }
    }

  }
}
